export default function customBreadcrump(pathname) {
  if (pathname.includes('/agents/list/')) {
    return { title: 'لیست مشاورین', sub: 'مشاور انتخاب شده' };
  }

  if (pathname.includes('/agents/list')) {
    return { title: 'لیست مشاورین' };
  }

  if (pathname.includes('/ads/create')) {
    return { title: 'مدیریت آگهی', sub: 'درج آگهی' };
  }

  if (pathname.includes('/ads/list/')) {
    return {
      title: 'مدیریت آگهی‌ها',
      sub: 'لیست آگهی‌ها',
      sub2: 'آگهی انتخاب شده',
    };
  }

  if (pathname.includes('/ads/list')) {
    return {
      title: 'مدیریت آگهی‌ها',
      sub: 'لیست آگهی‌ها',
    };
  }

  if (pathname.includes('/ads/edit')) {
    return { title: 'مدیریت آگهی‌ها', sub: 'ویرایش آگهی‌' };
  }

  if (pathname.includes('/settings')) {
    return { title: 'تنظیمات' };
  }

  if (pathname.includes('/subscription')) {
    return { title: 'مدیریت اشتراک' };
  }

  if (pathname.includes('/requests') || pathname.includes('/agents/invations')) {
    return { title: 'مدیریت درخواست ها' };
  }

  if (pathname.includes('/customers')) {
    return { title: 'مشتریان' };
  }

  if (pathname.includes('/help')) {
    return { title: 'راهنما' };
  }

  if (pathname.includes('/')) {
    return { title: 'داشبورد' };
  }
}
